/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../../tslib.es6-e01eabb2.js';

// 支付宝 easyShare: https://smallfish.antfin-inc.com/jsapi/easyShare.html
var showSharePanel = function (params, context) {
    var getAPShareData = function (options) {
        var _a;
        var _b = options !== null && options !== void 0 ? options : {}, _c = _b.businessId, businessId = _c === void 0 ? '' : _c, content = _b.content, image = _b.image;
        var ap = ((_a = options === null || options === void 0 ? void 0 : options._ext) !== null && _a !== void 0 ? _a : {}).ap;
        return __assign({ bizType: businessId, desc: content, iconUrl: image, imageUrl: image }, ap);
    };
    context.NBCall('easyShare', params, {
        formatInput: function (options) { return (__assign({}, getAPShareData(options))); },
    });
};

export { showSharePanel as default };
